module.exports = __webpack_public_path__ + "media/images/icons/hayawari-1fe083c351093af606d8c5174d027349.png";